import "./registerServiceWorker";
import Vue from "vue";
import App from "./app/App.vue";

import "./app/assets/scss/style.scss";

import Dictionary from "./app/shared/utils/pt_BR";
import router from "./app/router";
import store from "./app/store";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// import VueTheMask from "vue-the-mask";
import VueMask from "v-mask";
import VuePageTransition from "vue-page-transition";

import api from "./app/core/http/axios";
import endpoint from "./app/core/config/api";

import event_bus from "./app/shared/utils/event_bus";

import { iconsSet as icons } from "./app/assets/icons/icons";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";
import Vuelidate from "vuelidate";

import Vue2Filters from "vue2-filters";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import VueNativeNotification from "vue-native-notification";
Vue.use(VueNativeNotification, {
  requestOnNotify: true,
});

import VueImg from "v-img";
import VueTippy, { TippyComponent } from "vue-tippy";

import modalConfig from "./app/shared/utils/modal-config";

import VueMoment from "vue-moment";
import moment from "moment";
import "moment/locale/pt-br";

import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

import VueScreen from "vue-screen";

import VueGtm from "@gtm-support/vue2-gtm";

import PortalVue from "portal-vue";

Vue.use(PortalVue);

import VueLazyload from "vue-lazyload";
import isSharedWorker from "./app/shared/utils/is_shared_worker";

// import worker from "./app/shared/services/newWebsocket/worker-api";
import sharedWorker from "./app/shared/services/newWebsocket/sharedworker-api";

// import worker from "./app/shared/services/newWebsocket/worker-index";

import captcha from "./app/shared/utils/recaptcha";
import vClickOutside from "v-click-outside";

import jp from "jsonpath";
import money from "v-money";

Vue.use(money, { precision: 2 });

import getTickProfit from "./app/shared/utils/tick-sizes";
import ontick_colors from "./app/shared/utils/ontick_colors";

Vue.use(VueLazyload);

Vue.use(VueGtm, {
  id: "GTM-TNGL9ZN", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']

  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: "2726c7f26c", // Will add `nonce` to the script tag
  // enabled: true,
  enabled: process.env.NODE_ENV == "production" ? true : false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

// Base components
import OntickContainer from "@/app/shared/components/basic/ontick-container.component.vue";
import OntickCardTitle from "@/app/shared/components/basic/ontick-card-title.component.vue";
import OntickCard from "@/app/shared/components/basic/ontick-card.component.vue";
import OntickText from "@/app/shared/components/basic/ontick-text.component.vue";
import OntickButton from "@/app/shared/components/basic/ontick-button.component.vue";
import OntickInput from "@/app/shared/components/basic/ontick-input.component.vue";
import OntickFormInput from "@/app/shared/components/basic/ontick-form-input.component.vue";
// import OntickFormSelect from "@/app/shared/components/basic/ontick-form-select.component.vue";
import OntickFormDropdown from "@/app/shared/components/basic/ontick-form-dropdown.component.vue";
import OntickInputLarge from "@/app/shared/components/basic/ontick-input-large.component.vue";

import OntickTable from "@/app/shared/components/basic/ontick-table.component.vue";
import OntickTableTd from "@/app/shared/components/basic/ontick-table-td.component.vue";
import OntickTableTh from "@/app/shared/components/basic/ontick-table-th.component.vue";
import OntickTableTr from "@/app/shared/components/basic/ontick-table-tr.component.vue";
import OntickDiv from "@/app/shared/components/basic/ontick-div.component.vue";
import OntickSwitch from "@/app/shared/components/basic/ontick-switch.component.vue";
import OntickModal from "@/app/shared/components/basic/ontick-modal.component.vue";
import OntickAero from "@/app/shared/components/basic/ontick-aero.component.vue";
import OntickNumberInput from "@/app/shared/components/basic/ontick-number-input.component.vue";
import OntickAlertBadge from "@/app/shared/components/basic/ontick-alert-badge.component.vue";
// import ontickVue2DatetimePicker from "ontick-vue2-datetime-picker";

Vue.component("ontick-container", OntickContainer);
Vue.component("ontick-card-title", OntickCardTitle);
Vue.component("ontick-card", OntickCard);
Vue.component("ontick-div", OntickDiv);
Vue.component("ontick-text", OntickText);
Vue.component("ontick-button", OntickButton);
Vue.component("ontick-input", OntickInput);
Vue.component("ontick-input", OntickInput);
Vue.component("ontick-input-large", OntickInputLarge);
Vue.component("ontick-form-input", OntickFormInput);
// Vue.component("ontick-form-select", OntickFormSelect);
Vue.component("ontick-form-dropdown", OntickFormDropdown);
Vue.component("ontick-table", OntickTable);
Vue.component("ontick-table-td", OntickTableTd);
Vue.component("ontick-table-th", OntickTableTh);
Vue.component("ontick-table-tr", OntickTableTr);
Vue.component("ontick-switch", OntickSwitch);
Vue.component("ontick-modal", OntickModal);
Vue.component("ontick-aero", OntickAero);
Vue.component("ontick-number-input", OntickNumberInput);
Vue.component("ontick-alert-badge", OntickAlertBadge);
// Vue.component("ontick-datetime-picker", ontickVue2DatetimePicker);

const Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: false,
  },
  number: {
    format: "0",
    thousandsSeparator: ",",
    decimalSeparator: ".",
  },
  bytes: {
    decimalDigits: 2,
  },
  percent: {
    decimalDigits: 2,
    multiplier: 100,
  },
  currency: {
    symbol: "R$ ",
    decimalDigits: 2,
    thousandsSeparator: ".",
    decimalSeparator: ",",
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false,
  },
  pluralize: {
    includeNumber: false,
  },
  ordinal: {
    includeNumber: false,
  },
};

Vue.use(VueSweetalert2, {
  loaderHtml: icons.loading_blue,
  customClass: modalConfig,
  buttonsStyling: false,
  showCloseButton: true,
  closeButtonHtml: icons.modalCloseButton,
});
// Vue.use(VueTheMask);
Vue.use(VueMask);
Vue.use(Toast);
Vue.use(Vuelidate);
Vue.use(Vue2Filters, Vue2FiltersConfig);

Vue.use(VuePageTransition);
Validator.extend("cpf", {
  getMessage: (field) => `${field} inválido`,
  validate: (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf == "") return false;
    // Elimina CPFs invalidos conhecidos
    if (
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    )
      return false;
    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(9))) return false;
    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(10))) return false;
    return true;
  },
});
Vue.use(VeeValidate, { locale: "pt", dictionary: Dictionary });
Vue.filter("toPoints", function (value) {
  return parseFloat(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
  });
});
Vue.filter("toCurrencyDecimalPlacesOrPoints", function (value = 0, currency, minimumFractionDigits) {
  if (currency == "") {
    return currency + " " + parseFloat(value).toLocaleString("pt-BR", { minimumFractionDigits });
  } else {
    var newPrice = parseFloat(value).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits,
      signDisplay: "auto",
    });
    return newPrice;
    // return `${currency} ${newPrice.split("R$")[1].slice(1)}`;
  }
});

Vue.filter("toCurrency", function (value = 0, currency = "R$") {
  var newPrice = parseFloat(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return `${currency} ${newPrice.split("R$")[1].slice(1)}`;
});

Vue.filter("toLowerCase", function (value) {
  let color = value.toLowerCase();
  return color;
});

Vue.prototype.money = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  suffix: "",
  precision: 0,
  masked: true,
};
Vue.prototype.$event_bus = event_bus;
Vue.prototype.$colors = ontick_colors;
Vue.prototype.isSharedWorker = isSharedWorker;
Vue.prototype.worker = sharedWorker;
Vue.prototype.moment = moment;
Vue.prototype.jp = jp;
Vue.prototype.$icons = icons;
Vue.prototype.loading = false;
Vue.prototype.$api = api;
Vue.prototype.$endpoint = endpoint;
Vue.prototype.$websocket = {
  OnInit: null,
  waitConnection: null,
  ConsumeTopic: null,
  CheckLimit: null,
  ConsumeNotification: null,
  SendMessage: null,
};

Vue.prototype.isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);
Vue.prototype.$filters = {
  currency: (val) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(val);
  },
  capitalize: (val) => {
    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
  },
};
Vue.prototype.$recaptcha = captcha;
Vue.prototype.postDarkMode = (theme) => {
  localStorage.setItem("ui_theme", theme);
  // console.log(`era ${theme}, agora é ${localStorage.getItem("ui_theme")}`);
};
Vue.prototype.$getTickProfit = getTickProfit;

Vue.prototype.capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

Vue.use(VueImg);
Vue.use(vClickOutside);
Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true,
      },
    },
  },
  followCursor: "initial",
});
Vue.use(VueMoment, {
  moment,
});

Vue.component("tippy", TippyComponent);
Vue.use(VueMoment);
Vue.use(VueScreen, "tailwind");

// console.error = () => {};
new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});

// FORCE
